import { useState } from 'react';
import { NumericStepper } from '@components/NumericStepper';
import { SectionHeader } from './shared';
import styles from '../DemoPage.module.scss';

export const NumericStepperSection = () => {
  const [stepperValue, setStepperValue] = useState(6);
  const [stepperMinValue, setStepperMinValue] = useState(1);
  const [stepperMaxValue, setStepperMaxValue] = useState(20);

  return (
    <section className={styles.section}>
      <SectionHeader
        title="Numeric Stepper"
        description="A controlled numeric input with increment/decrement buttons. Supports min/max bounds and step values."
        figmaNodeId="258-1649"
        styles={styles}
      />

      <div className={styles.subsection}>
        <h3 className={styles.subsectionTitle}>Default (value: {stepperValue})</h3>
        <div className={styles.componentRow}>
          <NumericStepper value={stepperValue} onChange={setStepperValue} min={1} max={20} />
        </div>
        <p className={styles.hint}>Min: 1, Max: 20, Step: 1</p>
      </div>

      <div className={styles.subsection}>
        <h3 className={styles.subsectionTitle}>At Minimum (value: {stepperMinValue})</h3>
        <div className={styles.componentRow}>
          <NumericStepper value={stepperMinValue} onChange={setStepperMinValue} min={1} max={10} />
        </div>
        <p className={styles.hint}>Minus button disabled at min value</p>
      </div>

      <div className={styles.subsection}>
        <h3 className={styles.subsectionTitle}>At Maximum (value: {stepperMaxValue})</h3>
        <div className={styles.componentRow}>
          <NumericStepper value={stepperMaxValue} onChange={setStepperMaxValue} min={1} max={20} />
        </div>
        <p className={styles.hint}>Plus button disabled at max value</p>
      </div>

      <div className={styles.subsection}>
        <h3 className={styles.subsectionTitle}>Custom Step (step: 5)</h3>
        <div className={styles.componentRow}>
          <NumericStepper value={10} onChange={() => {}} min={0} max={100} step={5} />
        </div>
      </div>

      <div className={styles.subsection}>
        <h3 className={styles.subsectionTitle}>Disabled</h3>
        <div className={styles.componentRow}>
          <NumericStepper value={5} onChange={() => {}} disabled />
        </div>
      </div>
    </section>
  );
};
